import React from 'react';
import { BUSINESS, DELIVERY } from './businessInfo';

// Delivery & Pickup. Gateway reviewers expect a shipping/delivery policy even
// for prepared food, and it has to agree with what the order page actually
// offers — which is delivery or takeaway, chosen before checkout.
//
// The radius, charges and notice period come from DELIVERY in businessInfo.js.
//
// One <section> per heading: spacing on a phone, cards of a grid on a computer.
// The date and the opening paragraph sit outside them and span the page.

const DeliveryPolicy = () => (
    <div className="so-infopage">
        <p className="so-infopage__meta">
            Last updated: {BUSINESS.lastUpdated}
        </p>

        <p className="so-infopage__lead">
            {BUSINESS.brandName} prepares food to order. You choose delivery or pickup
            when you place a special order, and you can change it at checkout before
            paying.
        </p>

        <section className="so-infopage__section">
            <h3>Placing a special order</h3>
            <p>
                Special orders are for a future date. Please place them at least{' '}
                {DELIVERY.preOrderNoticeHours} hours ahead so the kitchen can plan the day's
                cooking around them. For large or unusual orders, call us first — we would
                rather confirm than disappoint.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>Delivery</h3>
            <ul>
                <li>
                    We deliver within about <strong>{DELIVERY.radiusKm} km</strong> of the
                    restaurant. Outside that, please choose pickup.
                </li>
                <li>
                    {DELIVERY.chargeNote
                        ? DELIVERY.chargeNote
                        : 'Any delivery charge is shown with the total before you pay.'}
                </li>
                {DELIVERY.minOrderNote && <li>{DELIVERY.minOrderNote}</li>}
                <li>
                    We deliver at the time you asked for, allowing for traffic and weather.
                    Food is packed for transport, but it is at its best soon after it arrives.
                </li>
                <li>
                    Please keep the phone number on the order reachable. Our rider will call on
                    arrival.
                </li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>Pickup</h3>
            <ul>
                <li>
                    Collect from the restaurant address on the Contact us page, at the time you
                    chose.
                </li>
                <li>
                    We hold a pickup order for <strong>{DELIVERY.pickupWindowMinutes} minutes</strong>{' '}
                    after that time. Call us if you are delayed.
                </li>
                <li>Quote your order number at the counter.</li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>If delivery cannot be completed</h3>
            <p>
                If nobody is reachable at the address and our rider cannot hand the order over,
                we will hold it at the restaurant for collection that day. Food that is neither
                delivered nor collected because we could not reach you cannot be refunded. If
                the failure is ours — we were late beyond any reasonable allowance, or the order
                never arrived — it is refunded in full under the Refund &amp; Cancellation policy.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>Things outside our control</h3>
            <p>
                Weather, traffic restrictions, strikes, power failures and similar disruptions
                can delay or prevent a delivery. When that happens we will contact you to
                reschedule or refund; we cannot pay compensation beyond the value of the order.
            </p>
        </section>
    </div>
);

export default DeliveryPolicy;
